import $ from 'jquery';
import contextGet from './context.get';
import blocks from './blocks/index';
import trigger from './trigger';
import config from './config';
/*
  TODO: Is this REALLY the way to 'manually' trigger click events?
*/
export default function anClickManual(scope, target) {
  var $scope = $(scope);
  var $target = $(target);
  if (config.debug && config.debug.logClicks) {
    console.log('DL 1.5 manual click');
  }
  trigger('aa-link', [
    contextGet($target, $scope), // provide start and end contexts
    blocks.linkBlock($target)
  ]);
};
